/**
 * Copyright (c) 2017 CA. All rights reserved.
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file for details.
 */

export default ( ) => ({
  checkBox: {
    width: '8%',
    paddingLeft: '6%',
  },
  customLabel: {
    width: '80%',
  },
  root: {
    height: 300,
    overflowY: 'auto',
  },
  menuItem: {},
  message: {
    textAlign: 'center',
    padding: 20,
  },
  customLabelItem: {
    display: 'inline-block',
    width: '50%',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  menuItemLabel: {
    marginLeft: 12,
    marginRight: 0,
  },
});
